"use client"

import * as Portal from "@radix-ui/react-portal"

import { useMounted } from "@/hooks/use-mounted"
import { Img } from "./image"

export function Loader() {
  const mounted = useMounted()

  if (!mounted) return null

  return (
    <Portal.Root>
      <div className="bg-loader fixed inset-0 z-100 flex items-center justify-center">
        <Img
          className="animate-spin"
          alt="Loader icon"
          src={"/assets/loader.svg"}
          width={60}
          height={60}
          priority
        />
      </div>
    </Portal.Root>
  )
}
